import { Link } from "react-router-dom";

const base =
  "inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-colors duration-300 disabled:opacity-60 disabled:cursor-not-allowed";

const sizes = {
  md: "px-6 py-3 text-sm",
  lg: "px-8 py-4 text-base",
};

const variants = {
  gold: "bg-gold text-navy hover:bg-gold-light",
  outline: "border border-gold/50 text-gold hover:bg-gold/10",
  ghost: "border border-white/15 text-white hover:border-white/40",
};

export function GoldButton({ to, href, children, variant = "gold", size = "md", className = "", ...rest }) {
  const cls = `${base} ${sizes[size]} ${variants[variant]} ${className}`;
  if (to) return <Link to={to} className={cls} {...rest}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...rest}>{children}</a>;
  return <button className={cls} {...rest}>{children}</button>;
}
